import ToastContextInterface, { ToastAction } from "@app/Interface/ToastContextInterface";
import ToastNotificationInterface from "@app/Interface/ToastNotificationInterface";
import IdContextManager from "@app/utils/IdContextManager";
import TypeAssertions from "@app/utils/TypeAssertions";

/**
 * Handles getting, adding, or deleting items in the ToastNotification state
 * for more information see: https://elisealcala.com/context-use-reducer-typescript/
 * 
 * @param toastState 
 * @param toastAction 
 * @returns 
 */
 export const toastNotificationReducer = (toastState: ToastContextInterface, toastAction: ToastAction): ToastContextInterface => {

    let notifications: ToastNotificationInterface[];

    let updatedState: ToastContextInterface;

    switch (toastAction.type) {

        case "GET":
            return toastState;

        case "ADD":

            // set the id
            toastAction.payload.id = IdContextManager.incrementToastNotificationId(toastState.toastNotices);         

            notifications = toastState.toastNotices;

            // add the new notifications
            notifications.push(toastAction.payload);
            
            // copy the original state and use the updated notifications
            updatedState = { ...toastState, toastNotices: notifications };

            return updatedState;

        case "DELETE":

            // Filter out the deleted notification
            notifications = toastState.toastNotices.filter( (notification) => {
                return notification.id !== toastAction.payload.id;
            });

            // copy the original state and use the updated notifications
            updatedState = { ...toastState, toastNotices: notifications };

            return updatedState;

        case "CLEAR":

            updatedState = {...toastState, toastNotices: []};

            return updatedState;

        default:
            // returns error if unhandled case  
            return TypeAssertions.assertNever(toastAction);
    }

}